import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { notify } from '../common/notify';
import { AgenturModel } from 'app/models/agentur.model';
import { AgtPlanModel } from 'app/stores/agt.plan.store';
import { AudioTranscriptionModal } from './AudioTranscriptionModal';

interface IAudioRecordingModal {
	agt: AgenturModel;
	plan: AgtPlanModel;
}

export const AudioRecordingModal = observer((props: IAudioRecordingModal) => {
	const { uiStore, documentUiStore } = useStore();

	const onDone = async (text: string) => {
		await documentUiStore.createTranscriptionDokument(text, props.agt, props.plan);
		notify('Sprachnotiz erstellt', '', 'success');
	};

	return <AudioTranscriptionModal modalId={uiStore.modalIds.audioRecording} doneLabel="Dokument erstellen" onDone={onDone} />;
});
